import dynamic from 'next/dynamic';

const ServiceVehiclesB2BGrid = dynamic(() =>
  import('./ServiceVehiclesB2BGrid/ServiceVehiclesB2BGrid')
);

const ServiceVehiclesB2BAdd = dynamic(() =>
  import('./ServiceVehiclesB2BAdd/ServiceVehiclesB2BAdd')
);

export { ServiceVehiclesB2BGrid, ServiceVehiclesB2BAdd };
